module.exports = __webpack_public_path__ + "img/img-main-rt-banner.87d480fb.png";